import {Injectable, OnInit} from '@angular/core';
import * as globals from '../settings';
import {LotteriesService} from '../lotteries.service';
import {SubscriptionsService} from './subscriptions.service';
import {JackpotPipe} from '../jackpot.pipe';
import {CurrencyPipe} from '@angular/common';
import {CurrencyService} from './currency.service';

@Injectable({
  providedIn: 'root'
})
export class IncomingdrawsService implements OnInit {
  public incomingDraws: any;
  currency: any;
  country: string;
  language: string;
  constructor(private lotteryService: LotteriesService, public subscriptionsService: SubscriptionsService,
              private jackpotPipe: JackpotPipe, private currencyPipe: CurrencyPipe,
              public currencyService: CurrencyService) {
      this.currency = this.currencyService.currency;
      this.country = localStorage.getItem('country');
      this.language = localStorage.getItem('pageLanguage');
      this.lotteryService.getLotteries(globals.appDomain + '/draws/incomingDraws/incomingDraws.html')
          .subscribe(
              result => {
                  if (result) {
                      this.incomingDraws = result;
                      // this.incomingDraws.map(draw => {
                      //     const jas = this.jackpotPipe.transform(this.currencyPipe.transform(draw.Jackpot, this.currency.Code,
                      //         this.currency.Symbol, '0.0', this.language), this.country.toLowerCase(),
                      //         this.currency.Symbol, this.language, false).replace(', ', ' ').replace('. ', ' ').split(' ');
                      //     draw.jackAsString = jas;
                      // });
                      this.subscriptionsService.updateIncomingDraws(this.incomingDraws);
                  }
              }
          );
  }

  ngOnInit() {

  }
}
